export default function getTimeOfDay(stage) {
    // Rounds 1 and 2 - Day
    let count = 0

    // Rounds 3 and 4 - Dusk
    if(stage.turn.number >= 5) {
        count = 1
    }

    // Rounds 5 and 6 - Night
    if(stage.turn.number >= 9) {
        count = 2
    }

    // Rounds 7 and 8 - Night
    if(stage.turn.number >= 13) {
        count = 3
    }

    // Rounds 9 and 10 - Night
    if(stage.turn.number >= 17) {
        count = 4
    }

    // Rounds 11+ - Night
    if(stage.turn.number >= 21) {
        count = 5
    }

    return count
}
